// C:\Users\abdul\Downloads\Onebox\onebox\src\components\Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = ({ tenant = {}, sections = {}, cartCount = 0, onOpenCart }) => {
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'home',         label: 'Home',         section: 'hero' },
    { id: 'about',        label: 'About',        section: 'about' },
    { id: 'menu',         label: 'Menu',         section: 'menu' },
    { id: 'testimonials', label: 'Testimonials', section: 'testimonials' },
    { id: 'footer',       label: 'Contact',      section: 'contact' },
  ].filter(item => sections?.[item.section]?.is_active !== false);

  const primaryColor = tenant?.primary_color || '#FF9F0D';

  const businessName = tenant?.business_name || 'Foodtuck';
  const words = businessName.trim().split(' ');
  const firstWord = words[0] || 'Food';
  const secondWord = words.slice(1).join(' ') || 'tuck';

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>

      {/* Logo */}
      <div className="navbar-logo-top">
        {tenant?.logo_url ? (
          <img
            src={tenant.logo_url}
            alt={businessName}
            className="navbar-logo-img"
          />
        ) : (
          <>
            <span className="logo-food">{firstWord}</span>
            <span className="logo-tuck" style={{ color: primaryColor }}>
              {secondWord}
            </span>
          </>
        )}
      </div>

      {/* Main Navigation Bar */}
      <div className="navbar-container">

        {/* Hamburger — mobile only */}
        <button
          className={`navbar-hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Nav Menu */}
        <ul className={`navbar-menu ${menuOpen ? 'navbar-menu-open' : ''}`}>
          {navItems.map((item) => (
            <li
              key={item.id}
              className={activeLink === item.id ? 'active' : ''}
            >
              <Link
                to={item.id}
                smooth={true}
                duration={500}
                spy={true}
                offset={-100}
                onSetActive={() => setActiveLink(item.id)}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </Link>
              {activeLink === item.id && (
                <span
                  className="active-dot"
                  style={{ backgroundColor: primaryColor }}
                ></span>
              )}
            </li>
          ))}
        </ul>

        {/* Search & Cart */}
        <div className="navbar-icons">
          <div className="search-container">
            <input
              type="text"
              placeholder="Search..."
              className="search-input"
            />
            <button className="search-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/>
                <path d="m21 21-4.35-4.35"/>
              </svg>
            </button>
          </div>

          {/* Cart Button with Badge */}
          <button
            className="cart-icon"
            onClick={onOpenCart}
            aria-label={`Open cart${cartCount > 0 ? `, ${cartCount} items` : ''}`}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            {cartCount > 0 && (
              <span
                className="cart-badge"
                style={{ backgroundColor: primaryColor }}
              >
                {cartCount > 99 ? '99+' : cartCount}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Mobile overlay */}
      {menuOpen && (
        <div
          className="navbar-overlay"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </nav>
  );
};

export default Navbar;
